import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/pointInfo', request)
}

export {get}
